import {
  Contrast,
  Download,
  Eye,
  Github,
  Linkedin,
  Mail,
  Type,
  X,
} from 'lucide-react'
import React from 'react'
import { usePortfolioStore } from '../../store'
import { SOCIAL_LINKS } from '../../types/navigation'
import Navigation from '../ui/Navigation'

const SidePanel: React.FC = () => {
  const {
    sidePanelVisible,
    setSidePanelVisible,
    accessibilityControls,
    updateAccessibilityControls,
    diagramMode,
    toggleDiagramMode,
  } = usePortfolioStore()

  const handleClose = () => {
    setSidePanelVisible(false)
  }

  const handleNavigationClick = () => {
    // Close sidebar when navigation item is clicked
    setSidePanelVisible(false)
  }

  const handleDownloadResume = () => {
    // Download the actual PDF resume from public folder
    const link = document.createElement('a')
    link.href =
      '/Lucas Stufflebeam-Principal Software Architect-Resume 2025.pdf'
    link.download =
      'Lucas Stufflebeam-Principal Software Architect-Resume 2025.pdf'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const getSocialIcon = (iconName: string) => {
    switch (iconName) {
      case 'linkedin':
        return <Linkedin size={20} />
      case 'github':
        return <Github size={20} />
      case 'mail':
        return <Mail size={20} />
      default:
        return null
    }
  }

  if (!sidePanelVisible) return null

  return (
    <>
      {/* Overlay */}
      <div className="side-panel-overlay" onClick={handleClose} />

      {/* Side Panel */}
      <div className="side-panel">
        <div className="side-panel-header">
          <h2>Navigation & Portfolio</h2>
          <button
            className="close-button"
            onClick={handleClose}
            aria-label="Close panel"
          >
            <X size={24} />
          </button>
        </div>

        <div className="side-panel-content">
          {/* Navigation Section */}
          <section className="panel-section">
            <h3>Pages</h3>
            <div className="sidebar-navigation">
              <Navigation
                className="sidebar-nav"
                onLinkClick={handleNavigationClick}
              />
            </div>
          </section>

          {/* Resume Section */}
          <section className="panel-section">
            <h3>Resume</h3>
            <div className="resume-actions">
              <button
                className="download-button"
                onClick={handleDownloadResume}
              >
                <Download size={16} />
                Download PDF
              </button>
              <a
                href="/resume"
                className="view-button"
                onClick={handleNavigationClick}
              >
                <Eye size={16} />
                View Online
              </a>
            </div>
          </section>

          {/* Social Links */}
          <section className="panel-section">
            <h3>Connect</h3>
            <div className="social-links">
              {SOCIAL_LINKS.map(link => (
                <a
                  key={link.label}
                  href={link.url}
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.label}
                >
                  {getSocialIcon(link.icon)}
                  <span>{link.label}</span>
                </a>
              ))}
            </div>
          </section>

          {/* Accessibility Controls */}
          <section className="panel-section">
            <h3>Accessibility</h3>
            <div className="accessibility-controls">
              {/*<label className="control-item">
                <input
                  type="checkbox"
                  checked={accessibilityControls.reducedMotion}
                  onChange={e =>
                    updateAccessibilityControls({
                      reducedMotion: e.target.checked,
                    })
                  }
                />
                <span>Reduce Motion</span>
              </label>*/}

              <label className="control-item">
                <input
                  type="checkbox"
                  checked={accessibilityControls.highContrast}
                  onChange={e =>
                    updateAccessibilityControls({
                      highContrast: e.target.checked,
                    })
                  }
                />
                <Contrast size={16} />
                <span>High Contrast</span>
              </label>

              <label className="control-item">
                <input
                  type="checkbox"
                  checked={accessibilityControls.largeText}
                  onChange={e =>
                    updateAccessibilityControls({ largeText: e.target.checked })
                  }
                />
                <Type size={16} />
                <span>Large Text</span>
              </label>
            </div>
          </section>

          {/* Future Enhancement */}
          {/*<section className="panel-section">
            <h3>Display Mode</h3>
            <label className="control-item">
              <input
                type="checkbox"
                checked={diagramMode}
                onChange={toggleDiagramMode}
                disabled
              />
              <span>Diagram Mode (Coming Soon)</span>
            </label>
          </section>*/}
        </div>
      </div>
    </>
  )
}

export default SidePanel
